<template>
  <div class="animated revealUp">
    <div class="d-flex justify-content-between align-item-center mb-3">
      <div class="section-title">{{ $t('view') }} {{ $t('cardtype') }}</div>
      <div>
        <button
          class="btn-blue"
          @click.prevent.stop="onEditCard(cardDetails.card_id)"
        >{{ $t('edit') }}</button>
        <router-link class="btn-blue" to="card-type">{{ $t('cardtype') }} {{ $tc('list', 1) }}</router-link>
      </div>
    </div>

    <div class="all-details-container">
      <div class="col-md-12 py-1">
        <div class="row">
          <div class="col-md-3 col-lg-2 col-xl-2">{{ $t('cardtype') }}</div>
          <div class="col-md-9 col-lg-10 col-xl-10">
            <span v-if="cardDetails.card_type" class="mr-3">{{cardDetails.card_type}}</span>
            <span v-else class="mr-3">-</span>
            <!-- <span>12:05 AM</span> -->
          </div>
        </div>
      </div>
      <div class="col-md-12 py-1">
        <div class="row">
          <div class="col-md-3 col-lg-2 col-xl-2">{{ $t('bank') }}</div>
          <div class="col-md-9 col-lg-10 col-xl-10">
            <span v-if="selected.bank" class="mr-3">{{selected.bank}}</span>
            <span v-else class="mr-3">-</span>
            <!-- <span>12:05 AM</span> -->
          </div>
        </div>
      </div>

      <div class="col-md-12 py-1">
        <div class="row">
          <div class="col-md-3 col-lg-2 col-xl-2">{{ $t('binNumbers') }}</div>
          <div class="col-md-9 col-lg-10 col-xl-10">
            <span
              class="mr-3"
            >{{ BinNumbers && BinNumbers.length > 0 ? BinNumbers.toString() : '-' }}</span>
            <!-- <span>12:05 AM</span> -->
          </div>
        </div>
      </div>

      <div v-if="roleID == 1" class="col-md-12 py-1">
        <div class="row">
          <div class="col-md-3 col-lg-2 col-xl-2">{{ $tc('cardtype') }} {{ $tc('active') }}</div>
          <div class="col-md-9 col-lg-10 col-xl-10">
            <span v-if="cardDetails.card_is_active=='Y'" class="mr-3">{{$t('yes')}}</span>
            <span v-else class="mr-3">{{$t('no')}}</span>
            <!-- <span>12:05 AM</span> -->
          </div>
        </div>
      </div>

      <div v-if="roleID == 1" class="col-md-12 py-1">
        <div class="row">
          <div class="col-md-3 col-lg-2 col-xl-2">{{ $t('createdat') }}</div>
          <div class="col-md-9 col-lg-10 col-xl-10">
            <span v-if="cardDetails.created_at" class="mr-3">{{cardDetails.created_at | dateparse}}</span>
            <span v-else class="mr-3">-</span>
            <!-- <span>12:05 AM</span> -->
          </div>
        </div>
      </div>
      <div v-if="roleID == 1" class="col-md-12 py-1">
        <div class="row">
          <div class="col-md-3 col-lg-2 col-xl-2">{{ $t('createdby') }}</div>
          <div class="col-md-9 col-lg-10 col-xl-10">
            <span v-if="cardDetails.created_by" class="mr-3">{{cardDetails.created_by}}</span>
            <span v-else class="mr-3">-</span>
            <!-- <span>12:05 AM</span> -->
          </div>
        </div>
      </div>
      <div v-if="roleID == 1" class="col-md-12 py-1">
        <div class="row">
          <div class="col-md-3 col-lg-2 col-xl-2">{{ $t('updatedat') }}</div>
          <div class="col-md-9 col-lg-10 col-xl-10">
            <span v-if="cardDetails.updated_at" class="mr-3">{{cardDetails.updated_at | dateparse}}</span>
            <span v-else class="mr-3">-</span>
            <!-- <span>12:05 AM</span> -->
          </div>
        </div>
      </div>
      <div v-if="roleID == 1" class="col-md-12 py-1">
        <div class="row">
          <div class="col-md-3 col-lg-2 col-xl-2">{{ $t('updatedby') }}</div>
          <div class="col-md-9 col-lg-10 col-xl-10">
            <span v-if="cardDetails.updated_by" class="mr-3">{{cardDetails.updated_by}}</span>
            <span v-else class="mr-3">-</span>
            <!-- <span>12:05 AM</span> -->
          </div>
        </div>
      </div>
    </div>
  </div>
</template>


<script>
import MarketingService from "@/services/MarketingService";
import MasterService from "@/services/MasterService";
import moment from "moment";

const selected = {
  bank: ""
};

export default {
  data() {
    return {
      roleID: "",
      card_id: "",
      card_type: "",
      banks: [],
      banksMethod: {
        GET: "/admin/",
        tableName: "ms_banks",
        urlKey: "banks"
      },
      selected: selected,
      items: [],
      cardDetails: {},
      viewdetails: false,
      BinNumbers: []
    };
  },

  beforeMount() {
    this.roleID = this.secureStore.get("USINFO").role_id;

    const { card_id } = this.$route.query;

    if (card_id) {
      this.getCardDetails(card_id);
    } else {
      this.$router.go(-1);
    }
  },
  mounted() {},
  methods: {
    getCardDetails: function(card_id) {
      MarketingService.getSingleCardDetails({ card_id }).then(response => {
        const { data } = response;

        if (data.Records) {
          this.cardDetails = {
            ...this.cardDetails,
            ...data.Records[0]
          };
          this.BinNumbers = data.BinNumbers.join(", ");
          this.getBankList(this.cardDetails.bank_id || null);
        }
      });
    },
    onEditCard: function(card_id) {
      this.$router.push({
        path: "/marketing/edit-card-type",
        query: { card_id: card_id }
      });
    },
    getBankList: function(bank_id) {
      this.banks = [];
      let body = this.getRequestBody("GET", undefined, this.banksMethod);
      MasterService.GlobalRequest(body)
        .then(response => {
          const { data } = response;
          if (data.status && data.Records.length > 0) {
            this.banks = data.Records;
            if (bank_id) {
              this.banks.map(x => {
                if (bank_id === x.bank_id) {
                  this.selected.bank = x.bank_name;
                }
              });
            }
          } else {
            //  this.$toasted.show("5"+data.message);
          }
        })
        .catch(this._CatchError);
    }
  }
};
</script>


// WEBPACK FOOTER //
// src/components/Pages/MarketingContainer/CardTypeComponents/viewMarketingCardType.vue